import type { PageTemplate, PageWidth } from '@beyond-js/ui';

type Rule = [pattern: RegExp, template: PageTemplate, width: PageWidth];

/**
 * What a page of the console is, read from its address (decision D52): the family page's template and the
 * width tier of its main column. Collections and an application's lists are fluid, a task is form wide, everything else
 * is standard; the frame is the same edge-to-edge region for all of them, its content one gutter after the sidebar.
 */
export class Layout {
	static #rules: Rule[] = [
		[/^\/o\/[^/]+\/applications\/(new|adopt)$/, 'task', 'form'],
		[/^\/o\/[^/]+\/applications\/[^/]+\/(registrations\/new|settings|targets\/new|access\/invite|domains\/new)$/, 'task', 'form'],
		[/^\/o\/[^/]+\/providers\/[^/]+$/, 'task', 'form'],
		[/^\/o\/[^/]+\/(applications|projects)$/, 'list', 'fluid'],
		// An application's lists and the registries are fluid as well, never capped narrower than their header (D162 L9)
		[/^\/o\/[^/]+\/applications\/[^/]+\/(registrations|jobs|releases|access|domains)$/, 'detail', 'fluid'],
		[/^\/o\/[^/]+\/providers$/, 'list', 'fluid'],
		[/^\/notifications$/, 'list', 'standard'],
		[/^\/o\/[^/]+\/consumption$/, 'overview', 'standard'],
		[/^\/o\/[^/]+\/plan$/, 'settings', 'standard']
	];

	#template: PageTemplate = 'detail';
	get template() {
		return this.#template;
	}

	#width: PageWidth = 'standard';
	get width() {
		return this.#width;
	}

	/** @param pathname The address shown */
	constructor(pathname: string) {
		const path = pathname.replace(/\/+$/, '');
		const rule = Layout.#rules.find(([pattern]) => pattern.test(path));
		if (!rule) return;
		[, this.#template, this.#width] = rule;
	}
}
